import Layout from '../../components/Layout/Layout';
import QuestionReport from './components/QuestionReport/QuestionReport';
import { EmojiYellow, EmojiGreen, EmojiOrange, EmojiRed } from '../../assets/img/svg/icons/Icons.js';
import './TrainingEvalReport.scss';
import useTrainingEvaluationScores from './logic/useTrainingEvalReport';
import { Alert, Spin } from 'antd';
import { formatDate } from "../../utils/dateFormatter";
import Mouse from '../../components/Mouse/Mouse.jsx';
import ScrollTop from '../../components/ScrollTop/ScrollTop.jsx';
import FlatTitle from '../LandingPage/components/ContactUs/components/FlatTitle.jsx';

function TrainingEvalReport() {
    const { data: evalScoreData, isFetching, error,trainingHeader } = useTrainingEvaluationScores();
    return (
        <div className="training-report-container">
            <FlatTitle pageName={"Evaluation Report"} />
            <div className="section-container">
                <div id="wrapper">
                {
                    isFetching ? <div className="training-report"><Spin /></div>
                        : error ? <Alert message="An error has occurred" type="error" showIcon />
                            : evalScoreData.code === 6000 ? <Alert message="No training found" type="info" showIcon />
                                : evalScoreData.code === 7000 ? <Alert message="there is no submitted evaluations yet" type="info" showIcon />
                                    : (!isFetching && !error) && <div className="training-report">

                                        <div className="training-report-title">
                                            <label>Training evaluation Report</label>
                                            <label>{trainingHeader && trainingHeader.course?.title} Course</label>
                                        </div>
                                        <div className="training-report-header">
                                            <div className="training-report-col">
                                                <div>
                                                    <label>Total participant: </label>
                                                    <label className="participant">{evalScoreData && evalScoreData.data.totalParticipant}</label>
                                                </div>
                                                <label>Trainer: {trainingHeader && trainingHeader.trainer?.firstName+" "+ trainingHeader.trainer?.lastName}</label>
                                            </div>
                                            <div className="training-report-col">
                                                <label>Course_Ref</label>
                                                <label>#54516546546</label>
                                            </div>
                                            <div className="training-report-col">
                                                <label>from : {trainingHeader && formatDate(trainingHeader?.start_date)}</label>
                                                <label>to : {trainingHeader && formatDate(trainingHeader?.end_date)}</label>
                                            </div>
                                        </div>
                                        <div className="training-report-score">
                                            <div className="training-report-total-score">
                                                <label>total Score : {Number(evalScoreData.data.totalAverages).toFixed(2)}</label>
                                            </div>
                                            <div className="training-report-emoji">
                                                <div className="training-report-emoji-score">
                                                    <EmojiGreen />
                                                    <div>
                                                        <label> {evalScoreData.data.verysatisfied}% Very satisfied </label>
                                                    </div>
                                                </div>
                                                <div className="training-report-emoji-score">
                                                    <EmojiYellow />
                                                    <div>
                                                        <label> {evalScoreData.data.satisfied}% satisfied </label>
                                                    </div>
                                                </div>
                                                <div className="training-report-emoji-score">
                                                    <EmojiOrange />
                                                    <div>
                                                        <label> {evalScoreData.data.ok}% Ok </label>
                                                    </div>
                                                </div>
                                                <div className="training-report-emoji-score">
                                                    <EmojiRed />
                                                    <div>
                                                        <label> {evalScoreData.data.unsatisfied}% Unsatisfied </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="review-training-questions-report">
                                            {
                                                evalScoreData.data.user_total_Average_score.map((userEval, index) =>
                                                    <QuestionReport key={index} name={userEval.name} totalAverage={userEval.totalAverage} trainingEvalScore={userEval.trainingEvaluationScores} />
                                                )
                                            }
                                        </div>
                                    </div>
                }

                    <Mouse />
                    <ScrollTop />
                </div>
            </div>
        </div>
    )
}

export default TrainingEvalReport; 
